module.exports = __webpack_public_path__ + "img/consTx.ca74d5c6.jpg";